import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading/loading.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { LogoutComponent } from './logout/logout.component';
import { SafePipe } from '../utils/safe.pipe';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TncDialogComponent } from './tnc-dialog/tnc-dialog.component';

@NgModule({
  declarations: [
    LoadingComponent,
    LogoutComponent,
    SafePipe,
    ConfirmDialogComponent,
    TncDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatProgressBarModule,
    MatMenuModule,
    MatTooltipModule,
    MatButtonModule,
    MatDialogModule
  ],
  exports: [
    LoadingComponent,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    SafePipe,
    LogoutComponent,
    MatProgressBarModule,
    MatMenuModule,
    ConfirmDialogComponent,
    MatTooltipModule,
    MatButtonModule,
    MatDialogModule,
    TncDialogComponent
  ]
})
export class SharedModule { }
